import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoSizeInputDirective } from '@df/ui/form/auto-size-input.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { QtySelectComponentDecoratorDef } from '../../../../ui/form/qty-select/qty-select.component.decorator';

@Component({
    standalone: true,
    imports: [FormsModule, NgClass, AutoSizeInputDirective, TranslationModule],
    selector: 'product-view-qty-select',
    templateUrl: './product-view-qty-select.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProducViewQtySelectComponent extends QtySelectComponentDecoratorDef {}
